/**************************************************************************************************/
/*   File: /src/app/shared/models/result.ts                                                       */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Thursday February 14th 2019                                                    */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Mon Apr 01 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The result of the operation
 */
export class Result {
    /**
     * The result of the operation
     */
    result: boolean;
}